import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "m-0 h-full",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "flex w-full h-full",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "questionCount" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Question", -1)
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { id: "currentQuestion" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"400"} }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { id: "allQuestions" }, "20", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionRating = _resolveComponent("QuestionRating")!
  const _component_StepperPanel = _resolveComponent("StepperPanel")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeQuestion - 63), 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(_component_Stepper, {
        linear: "",
        "unstyled:": "",
        true: "",
        "active-step": _ctx.activeSub,
        "onUpdate:activeStep": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSub) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleConnectivity')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 64)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "64",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 65)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "65",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 66)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "66",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 67)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "67",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleCompatibility')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 68)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "68",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 69)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "69",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 70)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "70",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 71)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "71",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleModularity')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 72)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "72",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 73)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "73",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 74)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "74",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 75)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "75",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleReusability')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 76)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "76",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 77)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "77",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 78)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "78",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 79)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "79",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleDataSharing')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 80)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "80",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 81)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "81",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 82)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "82",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 83)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "83",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-step"])
    ])
  ]))
}